import React from "react"
import { Box, Grid, Skeleton } from "@chakra-ui/react"
import ProductCardSkeleton from "./ProductCardSkeleton"

export const ProductListSkeleton: React.FC = () => {
  return (
    <Box>
      <Skeleton
        width="30%"
        height={{ base: "27px", md: "24px", "2xl": "28px" }}
        mt="12px"
        mb="16px"
      />

      <Grid
        templateColumns={{
          base: "repeat(1, minmax(0, 65%))",
          md: "repeat(4, 1fr)",
        }}
        display={{ base: "flex", md: "grid" }}
        overflowX={{ base: "scroll", md: "initial" }}
        gap={{ base: 4, lg: 8 }}
        pb={4}
        pt={0}
      >
        {[1, 2, 3, 4].map((_, index) => (
          <Box
            key={index}
            mb="4"
            width={{ base: "65%", md: "100%" }}
            flexShrink={0}
          >
            <ProductCardSkeleton />
          </Box>
        ))}
      </Grid>
    </Box>
  )
}
